import { useFilterDraft } from '@/hooks/useFilterDraft';

const SEARCH_TEXT_KEY = 'searchText';

type SearchTextValues = Record<typeof SEARCH_TEXT_KEY, string>;

const trimSearchText = (values: SearchTextValues): SearchTextValues => ({
  [SEARCH_TEXT_KEY]: values[SEARCH_TEXT_KEY].trim(),
});

interface UseUrlSyncedSearchOptions {
  appliedText: string | undefined;
  onApply: (text: string | undefined) => void;
}

export function useUrlSyncedSearch({ appliedText, onApply }: UseUrlSyncedSearchOptions) {
  const { draftValues, setDraftValues } = useFilterDraft<SearchTextValues>({
    appliedValues: { [SEARCH_TEXT_KEY]: appliedText ?? '' },
    normalizeValues: trimSearchText,
    onApply: (values) => onApply(values[SEARCH_TEXT_KEY] || undefined),
  });

  return {
    searchText: draftValues[SEARCH_TEXT_KEY],
    setSearchText: (text: string) => setDraftValues({ [SEARCH_TEXT_KEY]: text }),
  };
}
